var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / PG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-PG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Mask",
    fill: "#E8283F",
    mask: "url(#mask-2)",
    points: "0 0 28 0 28 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "6.66666667 16.6666667 5.72385763 16.942809 6 16 5.72385763 15.057191 6.66666667 15.3333333 7.60947571 15.057191 7.33333333 16 7.60947571 16.942809"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "6.66666667 8.66666667 5.72385763 8.94280904 6 8 5.72385763 7.05719096 6.66666667 7.33333333 7.60947571 7.05719096 7.33333333 8 7.60947571 8.94280904"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "3.33333333 12 2.39052429 12.2761424 2.66666667 11.3333333 2.39052429 10.3905243 3.33333333 10.6666667 4.27614237 10.3905243 4 11.3333333 4.27614237 12.2761424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "9.33333333 11.3333333 8.39052429 11.6094757 8.66666667 10.6666667 8.39052429 9.72385763 9.33333333 10 10.2761424 9.72385763 10 10.6666667 10.2761424 11.6094757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8612427,9.26556993 C18.7016228,9.16979803 18.5722254,8.94419828 18.5722254,8.76370997 L18.5722255,7.53499115 C18.5722255,7.35359345 18.4417146,7.2500452 18.2442218,7.31587611 L17.4860155,7.56861154 C17.3048641,7.62899534 17.027501,7.63444245 16.8300083,7.56861154 L16.071802,7.31587611 C15.8906506,7.25549231 15.8705221,7.1305073 16.0328156,7.03313122 L17.8118037,5.96573834 C17.9714235,5.86996646 18.0573173,5.66181708 17.9914864,5.46432437 L17.738751,4.70611807 C17.6783672,4.52496667 17.7599274,4.42161808 17.9574201,4.48744898 L18.7156264,4.74018442 C18.8967778,4.80056822 19.1196643,4.72279519 19.2170403,4.56050172 L20.2844332,2.78151359 C20.3802051,2.62189378 20.5013472,2.62300728 20.5671781,2.82049999 L20.8199135,3.57870629 C20.8802973,3.75985769 20.8857444,4.03722084 20.8199135,4.23471355 L20.5671781,4.99291985 C20.5067943,5.17407125 20.6058048,5.32092347 20.7862931,5.32092347 L22.015012,5.32092341 C22.1964097,5.3209234 22.4194958,5.44764717 22.5168719,5.60994064 L23.5842649,7.38892884 C23.6800367,7.54854866 23.6030244,7.70887625 23.4299413,7.74349286 L21.7283865,8.08380383 C21.5473841,8.12000431 21.3697224,8.30400145 21.3351058,8.47708452 L20.994795,10.1786394 C20.9585945,10.3596419 20.8025244,10.4303391 20.640231,10.332963 L18.8612427,9.26556993 L18.8612427,9.26556993 Z",
    id: "Rectangle-419",
    fill: "#FFD84E",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/PG.5ef1d1e7f13330fd1e222c913903e3cb.svg";
export { ForwardRef as ReactComponent };